import httpClient from "../utilis/jwtRequest";
import createFormData from "../utilis/formDataHelper";

const MAKLERS_URL = "/Brokers/";

function getAllMaklers() {
  return httpClient.get(MAKLERS_URL);
}
function add(newBroker) {
  const formData = createFormData(newBroker);
  return httpClient.post(MAKLERS_URL, formData);
}
function getMaklerById(id) {
  return httpClient.get(MAKLERS_URL + `${id}/`);
}
function getMaklerPointsById(id) {
  return httpClient.get(MAKLERS_URL + `${id}/points`);
}
function saveMaklerPointsById(id,data) {
  return httpClient.post(MAKLERS_URL + `${id}/points`,data);

}
function updateMakler(id, newBroker) {
  const formData = createFormData(newBroker);
  return httpClient.put(MAKLERS_URL + `${id}/`, formData);
}
function deleteMakler(id) {
  return httpClient.delete(MAKLERS_URL + `${id}/`);
}
function activateMakler(id) {
  return httpClient.post(MAKLERS_URL + `${id}/activate`);
}
function deactivateMakler(id) {
  return httpClient.post(MAKLERS_URL + `${id}/deactivate`);
}
function blockMakler(id) {
  return httpClient.post(`/Users/${id}/block`);
}
function unblockMakler(id) {
  return httpClient.post(`/Users/${id}/unblock`);
}

export const maklersService = {
  getAllMaklers,
  add,
  getMaklerById,
  updateMakler,
  deleteMakler,
  blockMakler,
  unblockMakler,
  activateMakler,
  deactivateMakler,
  getMaklerPointsById,
  saveMaklerPointsById,
};
